import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { StripeService } from '../../services/stripe.service';

@Component({
  selector: 'app-stripe-payment-status',
  templateUrl: './stripe-payment-status.component.html',
  styleUrls: ['./stripe-payment-status.component.scss'],
})
export class StripePaymentStatusComponent {
  session_id: string = '';
  status: string = '';
  isLoading: boolean = true;

  constructor(
    public modalRef: BsModalRef,
    public stripe: StripeService
  ) { }

  ngOnInit(): void {
    if (this.isLoading && this.session_id) {

      this.stripe.verifyingPayment(this.session_id).subscribe({
        next: (res) => {
          this.status = res?.data?.paid ? "success" : "failed"
          this.isLoading = false;
        },
        error: (err: any) => {
          console.log('stripe result', err);
          this.isLoading = false;
          this.status = "failed"
        },
      });
    }
  }

  close() {
    this.modalRef.hide();
  }
}
